module.exports = __webpack_public_path__ + "img/oie-betalning-visa.png";